import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {QuestionnaireForm} from "../forms";
import {questionnaireService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {STATUS_DRAFT} from "../../constants";

const toData = (order) => {
    return {
        title: null,
        description: null,
        status: STATUS_DRAFT,
        order: order,
        valid: false,
    }
};

const AddQuestionnaireDialog = (props) => {
    const { snackbar, order, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(order));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.title + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const questionnaire = {
            title: data.title,
            description: data.description,
            status: data.status,
            order: data.order,
        };

        questionnaireService.createQuestionnaire(questionnaire, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="add-questionnaire-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Add Form
        </ClosableDialogTitle>
        <DialogContent className="add-questionnaire-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <QuestionnaireForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(order), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default AddQuestionnaireDialog;
